'use strict';

wbApp.controller('CoursesScheduleCtrl', ['$scope', '$modal', '$translate', '$q', 'messageBoxSvc', 'courseScheduleSvc', 'securitySvc', 'courseSvc',
function ($scope, $modal, $translate, $q, messageBoxSvc, courseScheduleSvc, securitySvc, courseSvc) {

    var selectedCourse = null;
    var isActive = false;
    var loaded = false;
    $scope.courseSchedules = [];

    function reloadData(refresh) {
        if (selectedCourse) {
            $scope.courseSchedules = courseScheduleSvc.getAllAsync(selectedCourse.courseID, refresh, true);
            $scope.courseSchedules.$promise.then(function (data) {

                var acc = 1;
                _.forEach(_.orderBy(data, ['startDate'], ['asc'] ), function (schedule) {
                    if (schedule.recurrenceType !== 4) {
                        schedule.orderIdx = acc;
                        acc++;
                    } 
                });
            });
            loaded = true;
        }
    }

    function onCourseScheduleChanged(refresh) {
        reloadData(refresh);
        $scope.$emit('onCourseShouldRefresh', { course: $scope.selectedCourse });
    }

    $scope.$on('selectedCourseChanged', function (e, courseInd) {
        if (courseInd.course) {
            if (isActive) {
                if (selectedCourse !== courseInd.course || courseInd.refresh) {
                    selectedCourse = courseInd.course;
                    reloadData(courseInd.refresh);
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {            
            $scope.courseSchedules = [];
        }
        selectedCourse = courseInd.course;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 2) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedCourse) {
                    reloadData();
                }
            }
        } else {
            isActive = false;
        }
    });

    function newLesson() {
        courseDetailDialogPromise.$promise.then(function () {
            courseDetailDialogPromise.$scope.editRecurrence = false;
            courseDetailDialogPromise.$scope.model = courseScheduleSvc.createNew(selectedCourse);
            courseDetailDialogPromise.$scope.onSave = function () {
                onCourseScheduleChanged(true);
            };
            courseDetailDialogPromise.show();
        });
    }

    function newRecurrence() {
        courseDetailDialogPromise.$promise.then(function () {
            courseDetailDialogPromise.$scope.editRecurrence = true;
            courseDetailDialogPromise.$scope.model = courseScheduleSvc.createNew(selectedCourse, true);
            courseDetailDialogPromise.$scope.onSave = function () {
                onCourseScheduleChanged(true);
            };
            courseDetailDialogPromise.show();
        });
    }

    function changeRecurrence(lesson) {
        var pattern = courseScheduleSvc.getPattern(
            lesson.courseID, lesson.courseScheduleID);
        $q.all([pattern.$promise, courseDetailDialogPromise.$promise]).then(
            function () {
                courseDetailDialogPromise.$scope.editRecurrence = true;
                courseDetailDialogPromise.$scope.model = angular.copy(pattern);
                courseDetailDialogPromise.$scope.onSave = function () {
                    onCourseScheduleChanged(true);
                };
                courseDetailDialogPromise.show();
            });
    }


    function changeLesson(data) {
        courseDetailDialogPromise.$promise.then(function () {
            courseDetailDialogPromise.$scope.editRecurrence = false;
            courseDetailDialogPromise.$scope.model = angular.copy(data);
            courseDetailDialogPromise.$scope.onSave = function () {
                onCourseScheduleChanged(true);
            };
            courseDetailDialogPromise.show();
        });
    }

    function deleteSingleLessonNoRecurrence(event) {
        courseScheduleSvc.remove(
            event,
            {
                sendEmailNotification: true,
                sendSmsNotification: false
            },
            function () {
                onCourseScheduleChanged(true);
            }
        );
    }

    function deleteSingleLessonRecurrence(event) {
        courseScheduleSvc.remove(
            event,
            {
                sendEmailNotification: true,
                sendSmsNotification: false
            },
            function () {
                onCourseScheduleChanged(true);
            }
        );
    }

    function deleteRecurrence(event) {

        var pattern = courseScheduleSvc.getPattern(
            event.courseID, event.courseScheduleID)
        .$promise.then(function (pattern) {
            courseScheduleSvc.remove(
                pattern,
                {
                    sendEmailNotification: true,
                    sendSmsNotification: false
                },
                function () {
                    onCourseScheduleChanged(true);
                }
            );
        });
    }

    function getSelectedCourseName() {
        return courseSvc.getCourseFullName(selectedCourse);
    }

    function restoreEvent(event) {
        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_RESTORE',
            message: $translate.instant('TXT_TEXT_CONFIRM_RESTORE'),
            buttons: [{
                text: 'TXT_BTN_CANCEL'
            }, {
                text: 'TXT_RESTORE',
                callback: function () {
                    deleteSingleLessonRecurrence(event);
                }
            }]
        });
    }

    function deleteEvent(event) {
        if (event.recurrenceType === 0) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRM_DELETE',
                message: 'TXT_TEXT_CONFIRM_DELETE',
                buttons: [{
                    text: 'TXT_BTN_NO'
                }, {
                    text: 'TXT_BTN_YES',
                    callback: function () {
                        deleteSingleLessonNoRecurrence(event);
                    }
                }]
            });
        } else {
            // Recurrence
            var courseName = getSelectedCourseName();

            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRM_DELETE_RECURRENCE',
                message: $translate.instant('TXT_TEXT_CONFIRM_DELETE_RECURRENCE').f(courseName),
                buttons: [{
                    text: 'TXT_BTN_CANCEL'
                }, {
                    text: 'TXT_BTN_SERIES',
                    callback: function () {
                        deleteRecurrence(event);
                    }
                }, {
                    text: 'TXT_BTN_THIS_LESSON',
                    callback: function () {
                        deleteSingleLessonRecurrence(event);
                    }
                }]
            });
        }
    }


    $scope.courseSchedulesGridSettings = {
        name: 'courseSchedules',
        columns: [
            {
                dataField: 'courseScheduleID',
                caption: '#', 
                dataType: 'number',
                allowFiltering: false,
                cellTemplate: function (cellElement, cellInfo) {
                    $('<div >' + (cellInfo.data.orderIdx || '') + '</div>').appendTo(cellElement);
                },
                width: '35px'
            },
            {
                dataField: 'recurrenceId',
                caption: '',
                dataType: 'string',
                allowFiltering: false,
                cellTemplate: function (cellElement, cellInfo) {
                    if (cellInfo.data.recurrenceType === -1) {
                        $('<i class="fa fa-refresh" aria-hidden="true"></i>').appendTo(cellElement);
                    } else if (!!cellInfo.data.recurrenceType) {
                        $('<i class="fa fa-refresh text-danger" aria-hidden="true"></i>').appendTo(cellElement);
                    } 
                },
                width: '20px'
            },
            { dataField: 'startDate', caption: $translate.instant('TXT_LBL_START_DATE'), dataType: 'date', format: { raw: "dd.MM.yy EEE HH:mm" }, width: '130px', sortOrder: 'asc' },
            { dataField: 'endDate', caption: $translate.instant("TXT_LBL_END_DATE"), dataType: 'date', format: { raw: "HH:mm" }, width: '60px' },
            { dataField: 'classroomName', caption: $translate.instant('TXT_LBL_CLASSROOM'), dataType: 'string', width: '180px' },
            { dataField: 'teacher', caption: $translate.instant('TXT_LBL_EMPLOYEE'), dataType: 'string', width: '180px' },
            { dataField: 'filled', caption: $translate.instant('TXT_LBL_FILLED'), dataType: 'number', width: '70px' },
            { dataField: 'capacity', caption: $translate.instant('TXT_LBL_CAPACITY'), dataType: 'number', width: '70px' },
            {
                dataField: 'waitQueue',
                caption: $translate.instant('TXT_LBL_WAIT_QUEUE'),
                dataType: 'number',
                calculateCellValue: function (rowData) {
                    return rowData.waitQueue.length;
                },
                width: '70px'
            },
            { dataField: 'notes', caption: $translate.instant('TXT_NOTE'), dataType: 'string' }
        ],
        shouldDisableAdd: function () { return !$scope.selectedCourse; },
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.recurrenceType === 4) {
                    e.rowElement.addClass('text-muted');
                }
            }
        },
        customCommands: [{
            text: $translate.instant('TXT_LBL_NEW_LESSON'),
            isVisible: function () {
                return securitySvc.isInRole('CourseSchedule.Insert');
            },
            callback: function () {
                newLesson();
            }
        }, {
            text: $translate.instant('TXT_LBL_NEW_RECURRENCE'),
            isVisible: function () {
                return securitySvc.isInRole('CourseSchedule.Insert');
            },
            callback: function () {
                newRecurrence();
            }
        }, {
            text: $translate.instant('TXT_MENU_EDIT'),
            isVisible: function (event) {
                return !!event && event.recurrenceType !== 4 && securitySvc.isInRole('CourseSchedule.Update');
            },
            callback: function (event) {
                changeLesson(event);
            }
        }, {
            text: $translate.instant('TXT_LBL_CHANGE_RECURRENCE'),
            isVisible: function (event) {
                return !!event && event.recurrenceType !== 0 && event.recurrenceType !== 4 && securitySvc.isInRole('CourseSchedule.Update');
            },
            callback: function (event) {
                changeRecurrence(event);
            }
        }, {
            text: $translate.instant('TXT_MENU_DELETE'),
            isVisible: function (event) {
                return !!event && event.recurrenceType !== 4 && securitySvc.isInRole('CourseSchedule.Delete');
            },
            callback: function (event) {
                deleteEvent(event);
            }
        }, {
            text: $translate.instant('TXT_RESTORE'),
            isVisible: function (event) {
                return !!event && event.recurrenceType === 4 && securitySvc.isInRole('CourseSchedule.Delete');
            },
            callback: function (event) {
                restoreEvent(event);
            }
        }]
    }

    
    $scope.selectedSchedule = {};

    $scope.onRowSelected = function (data) {
        $scope.selectedSchedule = data;
    }

    $scope.onRowAdd = function () {
        var courseName = getSelectedCourseName();

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_QUESTION',
            message: $translate.instant('TXT_TEXT_CREATE_LESSON_OR_RECURRENCE').f(courseName),
            buttons: [{
                text: 'TXT_BTN_CANCEL'
            }, {
                text: 'TXT_BTN_CREATE_SERIES',
                callback: function () {
                    newRecurrence();
                }
            }, {
                text: 'TXT_BTN_SINGLE_LESSON',
                callback: function () {
                    newLesson();
                }
            }]
        });
    }

    var courseDetailDialogPromise = $modal({
        templateUrl: 'schedule/schedule-course-detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);
